module.exports = __webpack_public_path__ + "static/media/rstudio-icon.b72a04a4.svg";